import { useState, useEffect } from 'react'
import cn from 'clsx'

const LazyImage = ({
    className,
    src,
    delayMillis = 500,
    ...props
} = {}) => {
    
    const [source, setSource] = useState()
    
    useEffect(() => {
        
        const t = setTimeout(() => {
            // console.info('LazyImage loading', src)
            setSource(src)
        }, delayMillis)
        
        return () => clearTimeout(t)
        
    }, [src])
    
    if (!source)
        return null
    
    return (
        
        <img
            className={cn('LazyImage', className)}
            src={source}
            loading="lazy"
            {...props} />
        
    )
    
}

export default LazyImage
